export const initFormData = {
  mobile: "",
  mobile_code: "",
  new_password: "",
  repeat_new_password: ""
};
